import React from 'react';
import { Box } from '@chakra-ui/react';
import Link from '@components/atoms/Link';
import ProductCardBody from '@components/molecules/ProductCardBody';
import { dataLayerProductClick } from '@helpers/dataLayerPush';

const ProductCard = ({
  productData,
  children,
  isClickable = false,
  isOdd = false,
  orderIndex
}) => {
  const onButtonClick = ({
    productId,
    productName,
    productIndex,
    productBrand,
    productPrice
  }) => {
    dataLayerProductClick({
      event: `select_item`,
      productId,
      productName,
      productIndex,
      productBrand,
      productPrice
    });
    dataLayerProductClick({
      event: `view_item`,
      productId,
      productName,
      productIndex,
      productBrand,
      productPrice
    });
  };
  return (
    <Box
      height="100%"
      minHeight={{ base: `none`, lg: `22rem` }}
      mt={{ base: isOdd ? `0` : `1.5rem`, md: `0` }}>
      {isClickable ? (
        <Link
          href={`/products/${productData.slug}`}
          _hover={{
            textDecoration: `none`
          }}
          onClick={() => {
            onButtonClick({
              productId: productData.id,
              productName: productData.title,
              productIndex: orderIndex,
              productBrand: productData.brand.title,
              productPrice: productData.price
            });
          }}>
          <ProductCardBody productData={productData} isClickable={isClickable}>
            {children}
          </ProductCardBody>
        </Link>
      ) : (
        <ProductCardBody productData={productData}>{children}</ProductCardBody>
      )}
    </Box>
  );
};

export default ProductCard;
